import axios from 'axios';
import store from '../store';
import token from './token';

function disableLoading({ url }) {
  if (url.includes('/notifications/') || url.includes('?requested_to=')) return true;
  return false;
}

export default {
  initAxiosInterceptors() {
    // BEFORE request
    axios.interceptors.request.use(
      async (request) => {
        // show loader BEFORE API request send
        if (!disableLoading(request)) store.dispatch('startLoading');
        // check if request uses auth, if yes check the token expire
        if (request.headers.Authorization) {
          // getting access token
          const access = store.getters['auth/access'];
          if (!access) {
            // logout user if access token is undefinded
            await store.dispatch('auth/userLogout');
          } else if (token.checkAccessExpire()) {
            // refresh tokens pair if current token is expired
            await store.dispatch('auth/userRefresh');
            // update auth token on current request
            request.headers.Authorization = `Bearer ${store.getters['auth/access']}`;
          }
        }
        return request;
      },
      (e) => {
        // hide loader on error
        store.dispatch('endLoading');
        return Promise.reject(e);
      },
    );
    // first place that every request response appear
    axios.interceptors.response.use(
      (response) => {
        // response success based on HTTP status >400
        // hide loader on success response
        store.dispatch('endLoading');
        // flush alerts (if there is any alert it will hide it)
        store.dispatch('flushAlert');
        return response;
      },
      (e) => {
        if (e.response) {
          // get error response means that HTTP status >=400
        // hide loader in any response
          store.dispatch('endLoading');
          // user should login when token expired
          if (
            e.response.data.name === 'JsonWebTokenError'
          || e.response.data.name === 'TokenExpiredError'
          ) {
            store.dispatch('auth/userLogout');
            return Promise.reject(e);
          }
          // show alert message on 500 server error
          switch (e.response.status) {
            case 500:
              store.dispatch('initAlert', {
                type: 'error',
                message: e.response.data.message,
              });
              break;
            default:
              break;
          }
        }
        return Promise.reject(e);
      },
    );
  },
};
